// O react-bootstrap entrega a opção escolhida como texto ("0" no Pendente) e o "Selecione" como null.
export function codigoOuNulo(valor: string | number | null): number | null {
  return valor === null ? null : Number(valor);
}
